import React from 'react';
import PropTypes from 'prop-types';

import { CurrencyInput } from 'ui-components/components/currency-input';

import style from './style.module.css';
import { DriverTipTooltip } from './tooltip';

export const DriverTipInput = ({ currencyCode, onBlur, onChange, currencyValue }) => {
  return (
    <div className={style.inline}>
      <CurrencyInput
        className={style['csw-input-short']}
        currencyCode={currencyCode}
        data-testid='driver-tip'
        onBlur={onBlur}
        onChange={onChange}
        value={currencyValue}
      />
      <DriverTipTooltip />
    </div>
  );
};

DriverTipInput.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  currencyValue: PropTypes.number,
};
